import React, { useState } from 'react';
import { withRouter } from 'react-router'
import EditIcon from '@material-ui/icons/Edit';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { onCheckFormPermission } from '../../../utils_v2';
import { engineConditionConfig } from '.';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { Grid, Table, TableBody, TableHead, Paper, TextField, TableRow, TableCell, Button, Tooltip, IconButton } from '@material-ui/core';
function InstalledEngine({ params, data, onFieldChange, currentFormDetail, setUploadPicture, setSliderInfo, isLoading, setInitialValue, callthisapi, setDeletPicture, getResponseBack, formSave, setFormSave }) {

    return (
        <section className='installed-engine'>
            <Paper square style={{ padding: '10px', marginBottom: "5px" }} elevation={8}>
                <ul className='list-inline'>
                    <li className='list-inline-item'> <h4>Installed Engine</h4></li>
                    <li className='list-inline-item' style={{ float: 'right' }}>
                        {!(formSave?.type === 'installed' && formSave?.open) && (
                            <Tooltip title="Edit" placement="top">
                                <IconButton disabled={!onCheckFormPermission(currentFormDetail) || formSave?.isdisabled} style={{ cursor: 'pointer' }} color="primary" size="small" onClick={() => setFormSave({ open: true, type: 'installed',isdisabled:true })} > <EditIcon /> </IconButton>
                            </Tooltip>
                        )}
                        {formSave?.type === 'installed' && (
                            <>
                                <Tooltip title="Cancel" placement="top">
                                    <Button style={{ marginInline: '5px' }} variant="outlined" color="primary" onClick={() => { getResponseBack('noloader'); setFormSave({ open: false, type: '' ,isdisabled:false}); }} size="small" > Cancel </Button>
                                </Tooltip>
                                <Tooltip title="Save" placement="top">
                                    <Button variant="contained" color="primary" onClick={() => { callthisapi('', data); setFormSave({ open: false, type: '',isdisabled:false }); }} size="small" > Save </Button>
                                </Tooltip>
                            </>
                        )}
                    </li>
                </ul>
                <Table className='mui-table-format-t015'>
                    <TableBody>
                        <TableRow>
                            <TableCell style={{ width: '25%' }}><h6>Aircraft Registration</h6></TableCell>
                            <TableCell style={{ width: '25%' }}>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'installed'}
                                    variant='outlined'
                                    margin='normal'
                                    id='aircraft_reg'
                                    value={data?.aircraft_reg || ''}
                                    placeholder="Enter.."
                                    fullWidth
                                    onChange={(e) => onFieldChange(e, 'aircraft_reg', e.target.value)}
                                    inputProps={{ maxLength: 50, style: { fontSize: 14 } }}
                                />
                            </TableCell>
                            <TableCell style={{ width: '25%' }}><h6>Position</h6> </TableCell>
                            <TableCell style={{ width: '25%' }}>
                                <Autocomplete
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'installed'}
                                    options={[{ id: '1', label: "LH-1" }, { id: '2', label: "RH-2" }, { id: '0', label: "None" }]}
                                    getOptionLabel={option => option?.label}
                                    id="position"
                                    value={data?.position || null}
                                    onChange={(e, value) => onFieldChange(e, 'position', value)}
                                    renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' margin="normal" fullWidth />}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Table className='mui-table-format-t015'>
                    <TableHead>
                        <TableRow>
                            <TableCell align='center' colSpan={2}> <h6>Description</h6></TableCell>
                            <TableCell align='center'> <h6>Condition</h6></TableCell>
                            <TableCell align='center'> <h6>Notes</h6></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell align='center' width='25' rowSpan={9} style={{ writingMode: 'sideways-lr' }}> <h6>Walk Around Check</h6></TableCell>
                        </TableRow>
                        {engineConditionConfig?.map((item, index) => (
                            <TableRow key={index}>
                                {item?.description === 'Photo' ? null : <TableCell align='center' width='250' >{item?.description} </TableCell>}
                                {item?.conditionKey === 'spotcheck_lru_sn' ? <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'installed'}
                                        variant='outlined'
                                        margin='normal'
                                        placeholder="Enter.."
                                        fullWidth
                                        inputProps={{ maxLength: 250, style: { fontSize: 14 } }}
                                        value={data?.installed_engine_condition && data?.installed_engine_condition['spotcheck_lru_sn'] || null}
                                        onChange={(e) => onFieldChange(e, item?.noteKey, e.target.value, 'installed_engine_condition')}
                                    />
                                </TableCell>
                                    :
                                    item?.conditionKey === 'photo_condition' ?
                                        <TableCell colSpan={3} style={{ maxWidth: '82vw', position: 'relative' }} >
                                            <div style={{ position: 'sticky', zIndex: '1', padding: '4px' }}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={2} style={{ textAlign: 'center', marginTop: '10px' }}>Photo</Grid>
                                                    <Grid item xs={6} style={{ textAlign: 'end', marginTop: '10px' }}>Availability </Grid>
                                                    <Grid item xs={1}>
                                                        <Autocomplete
                                                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'installed'}
                                                            options={['YES', 'NO'] || []}
                                                            getOptionLabel={option => option}
                                                            value={['YES', 'NO'].filter(item => item === data?.installed_engine_photo_availability)[0] || null}
                                                            id="installed_engine_photo_availability"
                                                            onChange={(e, value) => onFieldChange(e, 'installed_engine_photo_availability', value)}
                                                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" InputLabelProps={{ shrink: true }} />}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={3} style={{ textAlign: 'end' }}>
                                                        <span style={{ color: "#3f51b5", fontFamily: 'Conv_IBMPlexSans-Medium' }}> {`Uploaded Photos: (${data?.installed_engine_photo?.length})` + "   "}</span>
                                                        <Button disabled={formSave?.isdisabled || !onCheckFormPermission(currentFormDetail) || data?.installed_engine_photo?.length >= 16} onClick={() => setUploadPicture({ modal: true, data: 1 })} variant='contained' size='small' color='primary'>Upload</Button>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                            <div style={{ overflowX: data?.installed_engine_photo?.length ? 'scroll' : '', display: data?.installed_engine_photo?.length ? '-webkit-inline-box' : '', width: '100%' }}>
                                                {data?.installed_engine_photo?.map((items, index) => (
                                                    <div>
                                                        <Paper square elevation={1} style={{ height: '40px', margin: '0px 10px 0px' }}>
                                                            <div className="dropped-picture-cta" style={{ background: 'rgba(255, 255, 255, 0.5) ' }}>
                                                                <Tooltip title='view'>
                                                                    <IconButton style={{ float: 'right' }} aria-label="" onClick={(e) => setSliderInfo({ modal: true, title: 'Photo', startIndex: index, images: data?.installed_engine_photo?.map(item => { return { original: item?.url, thumbnail: item?.url } }), })}>
                                                                        <VisibilityIcon color="primary" fontSize='small' />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                {!onCheckFormPermission(currentFormDetail) ? null : <Tooltip title='Delete' >
                                                                    <IconButton  disabled={formSave?.isdisabled} style={{ float: 'right'}} onClick={() => setDeletPicture({ modal: true, data: items })}>
                                                                        <Tooltip title='Delete' arrow><DeleteOutlineIcon  color={formSave?.isdisabled ? '' : "secondary"} fontSize='small' style={{cursor:'pointer'}} /></Tooltip>
                                                                    </IconButton>
                                                                </Tooltip>}
                                                            </div>
                                                        </Paper>
                                                        <div className="dropped-pic-card"
                                                            style={{
                                                                backgroundImage: `url(${items?.url})`,
                                                                backgroundSize: 'contain',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat',
                                                                width: '300px',
                                                                height: '210px',
                                                                border: 'groove 1px',
                                                                borderColor: 'lightgray',
                                                                margin: '0px 10px 10px 10px',
                                                            }}
                                                        >
                                                        </div>
                                                    </div>
                                                )
                                                )}
                                            </div>
                                        </TableCell>
                                        :
                                        <TableCell width='300' style={{ textAlignLast: 'center' }}>
                                            <Autocomplete
                                                disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'installed'}
                                                options={item?.dropdown || []}
                                                getOptionLabel={option => option}
                                                value={data?.installed_engine_condition && data?.installed_engine_condition[item?.conditionKey] || null}
                                                id="position"
                                                onChange={(e, value) => onFieldChange(e, item?.conditionKey, value, 'installed_engine_condition')}
                                                renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                                            />
                                        </TableCell>}
                                {item?.noteKey === 'photo_note' ? null
                                    :
                                    <TableCell style={{ textAlignLast: 'center' }}>
                                        <TextField
                                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'installed'}
                                            variant='outlined'
                                            margin='normal'
                                            placeholder="Enter.."
                                            fullWidth
                                            inputProps={{ maxLength: 250, style: { fontSize: 14 } }}
                                            value={data?.installed_engine_notes?.[item?.noteKey] || ''}
                                            onChange={(e) => onFieldChange(e, item?.noteKey, e.target.value, 'installed_engine_notes')}
                                        /></TableCell>
                                }
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <Paper square elevation={1} style={{ position: 'sticky', zIndex: '1', padding: '5px' }}>
                    <ul className='list-inline'>
                        <li className='list-inline-item'> <h6 style={{ padding: "5px 0px" }}>Engine Data Plate:</h6></li>
                        <li className='list-inline-item' style={{ float: 'right' }}>
                            <span style={{ color: "#3f51b5", fontFamily: 'Conv_IBMPlexSans-Medium', fontSize: "14px" }}>{`Uploaded Photos: (${data?.installed_engine_data_plate_photo?.length})` + "   "}</span>
                            <Button disabled={formSave?.isdisabled || !onCheckFormPermission(currentFormDetail) || data?.installed_engine_data_plate_photo?.length >= 16} onClick={() => setUploadPicture({ modal: true, data: 2 })} variant='contained' size='small' color='primary'>Upload</Button>
                        </li>
                    </ul>
                    <div style={{ overflowX: data?.installed_engine_data_plate_photo?.length ? 'scroll' : '', display: data?.installed_engine_data_plate_photo?.length ? '-webkit-inline-box' : '', width: '100%' }}>
                        {data?.installed_engine_data_plate_photo?.map((items, index) => (
                            <div>
                                <Paper square elevation={1} style={{ height: '40px', margin: '0px 10px 0px' }}>
                                    <div className="dropped-picture-cta" style={{ background: 'rgba(255, 255, 255, 0.5) ' }}>
                                        <Tooltip title='view'>
                                            <IconButton style={{ float: 'right'}} aria-label="" onClick={(e) => setSliderInfo({ modal: true, title: 'Engine Data Plate', startIndex: index, images: data?.installed_engine_data_plate_photo?.map(item => { return { original: item.url, thumbnail: item.url } }), })}>
                                                <VisibilityIcon color="primary" fontSize='small' />
                                            </IconButton>
                                        </Tooltip>
                                        {!onCheckFormPermission(currentFormDetail) ? null : <Tooltip title='Delete' >
                                            <IconButton disabled={formSave?.isdisabled } style={{ float: 'right'}} onClick={() => setDeletPicture({ modal: true, data: items })}>
                                                <Tooltip title='Delete' arrow><DeleteOutlineIcon   color={formSave?.isdisabled  ? '' : "secondary"} fontSize='small' style={{cursor:'pointer'}} /></Tooltip>
                                            </IconButton>
                                        </Tooltip>}
                                    </div>
                                </Paper>
                                <div className="dropped-pic-card"
                                    style={{
                                        backgroundImage: `url(${items?.url})`,
                                        backgroundSize: 'contain',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        width: '300px',
                                        height: '210px',
                                        border: 'groove 1px',
                                        borderColor: 'lightgray',
                                        margin: '0px 10px 10px 10px',
                                    }}
                                >
                                </div>
                            </div>
                        )
                        )}
                    </div>
                    <Grid conatiner spacing={2}>
                        <Grid item xs={12} md={12} sm={12}>
                            <TextField
                                disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'installed'}
                                variant='outlined'
                                margin='normal'
                                placeholder="Enter.."
                                fullWidth
                                label="Text"
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 250, style: { fontSize: 14 } }}
                                value={data?.installed_engine_engine_data_plate_text || null}
                                onChange={(e) => onFieldChange(e, 'installed_engine_engine_data_plate_text', e.target.value,)}
                            />
                        </Grid>
                    </Grid>
                </Paper>
                <Paper square elevation={1} style={{ position: 'sticky', zIndex: '1', padding: '4px', marginTop: '10px' }}>
                    <ul className='list-inline'>
                        <li className='list-inline-item'> <h6 style={{ padding: "5px 0px" }}>Engine Owner Plate:</h6>
                            <p style={{ fontSize: '14px' }}>- For assets not owned by SAEL, state if any ownership dataplate is installed.</p>
                            <p style={{ fontSize: '14px' }}>- For assets which are owned by SAEL, confirm whether or not one is installed and if so, advise text of statement or inserting a photo.</p>
                        </li>
                        <li className='list-inline-item' style={{ float: 'right' }}>
                            <span style={{ color: "#3f51b5", fontFamily: 'Conv_IBMPlexSans-Medium', fontSize: "14px" }}>{`Uploaded Photos: (${data?.installed_engine_owner_plate_photo?.length})` + "   "}</span>
                            <Button disabled={formSave?.isdisabled || !onCheckFormPermission(currentFormDetail) || data?.installed_engine_owner_plate_photo?.length >= 16} onClick={() => setUploadPicture({ modal: true, data: 3 })} variant='contained' size='small' color='primary'>Upload</Button>
                        </li>
                    </ul>

                    <div style={{ overflowX: data?.installed_engine_owner_plate_photo?.length ? 'scroll' : '', display: data?.installed_engine_owner_plate_photo?.length ? '-webkit-inline-box' : '', width: '100%' }}>
                        {data?.installed_engine_owner_plate_photo?.map((items, index) => (
                            <div>
                                <Paper square elevation={1} style={{ height: '40px', margin: '0px 10px 0px' }}>
                                    <div className="dropped-picture-cta" style={{ background: 'rgba(255, 255, 255, 0.5) ' }}>
                                        <Tooltip title='view'>
                                            <IconButton style={{ float: 'right'}} aria-label="" onClick={(e) => setSliderInfo({ modal: true, title: 'Engine Data Plate', startIndex: index, images: data?.installed_engine_owner_plate_photo?.map(item => { return { original: item?.url, thumbnail: item?.url } }), })}>
                                                <VisibilityIcon color="primary" fontSize='small' />
                                            </IconButton>
                                        </Tooltip>
                                        {!onCheckFormPermission(currentFormDetail) ? null : <Tooltip title='Delete' >
                                            <IconButton disabled={formSave?.isdisabled}  style={{ float: 'right',}} onClick={() => setDeletPicture({ modal: true, data: items })}>
                                                <Tooltip title='Delete' arrow><DeleteOutlineIcon color={formSave?.isdisabled  ? '' : "secondary"} fontSize='small' style={{cursor:'pointer'}} /></Tooltip>
                                            </IconButton>
                                        </Tooltip>}
                                    </div>
                                </Paper>
                                <div className="dropped-pic-card"
                                    style={{
                                        backgroundImage: `url(${items?.url})`,
                                        backgroundSize: 'contain',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        width: '300px',
                                        height: '210px',
                                        border: 'groove 1px',
                                        borderColor: 'lightgray',
                                        margin: '0px 10px 10px 10px',
                                    }}
                                >
                                </div>
                            </div>
                        )
                        )}
                    </div>
                    <Grid conatiner spacing={2}>
                        <Grid item xs={12} md={12} sm={12}>
                            <TextField
                                disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'installed'}
                                variant='outlined'
                                margin='normal'
                                placeholder="Enter.."
                                fullWidth
                                label="Text"
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 250, style: { fontSize: 14 } }}
                                value={data?.installed_engine_owner_plate_text || null}
                                onChange={(e) => onFieldChange(e, 'installed_engine_owner_plate_text', e.target.value,)}
                            />
                        </Grid>
                    </Grid>
                </Paper>
                <h6 style={{ margin: "5px 0px 0px 0px" }}>Overall Condition:</h6>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12} sm={12}>
                        <TextField
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'installed'}
                            variant='outlined'
                            margin='normal'
                            placeholder="Enter.."
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 250, style: { fontSize: 14 } }}
                            value={data?.installed_engine_overall_condition || ''}
                            onChange={(e) => onFieldChange(e, 'installed_engine_overall_condition', e.target.value)}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </section >
    )
}

export default withRouter(InstalledEngine)